import React, { useEffect } from "react";
import { useSelector } from 'react-redux';
import jwt_decode from "jwt-decode";
import { JWT_TOKEN } from "../global/constants";
import RedirectGuard from "../hoc/RedirectGuard";
import PermissionGuard from "../hoc/PermissionGuard";
import { Navigate, useLocation } from "react-router-dom";
import { isResourceCoordinator } from "../utils/FeatureUtils.js/FeatureUtils";
import { bundleManifest, bundleRouteAvailable } from '../global/bundle';
import { useTranslation } from 'react-i18next';

const securityCheck = (token) => {
  //console.log(token);
  if(token == null){
        return false ;
  } else {
        let decoded_jwtToken =  jwt_decode(token);
        //console.log(decoded_jwtToken.exp);
        if (Date.now() >= decoded_jwtToken.exp * 1000) {
          return false;
        }
        return true;
   }
  }

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ component: Component, permission }) => {
  const { t } = useTranslation();
  const { isAuth, error } = useSelector(state => state.security);
  // The LIVE location, not a route captured when the app mounted: App renders the
  // catch-all element once (at /login), so a prop read from window.location there is
  // stale after the login form navigates. The coordinator guard below then saw "/login"
  // on /tasks/task-focus and redirected to the page it was already on, forever — a blank
  // first sign-in that only a reload (a fresh mount) cured. (COORD-BLANK, 2026-09-25)
  const location = useLocation();
  const route = location.pathname + location.search;
  const token = localStorage.getItem(JWT_TOKEN);
  useEffect(() => {
    if (bundleManifest() && bundleRouteAvailable(location.pathname)) {
      sessionStorage.setItem('offolio.bundle.returnPath', route);
    }
  }, [location.pathname, route]);

  if(token != null && !error && securityCheck(token)){
    if (!bundleRouteAvailable(location.pathname)) {
      return <div role="status" data-testid="bundle-feature-unavailable">{t('bundle.notAvailable', 'Not available in this bundle.')}</div>;
    }
    // Resource Coordinator's whole scope is the My Look Ahead Plan page: one central
    // guard instead of touching every route's permission. Redirecting here (not in
    // PermissionGuard, whose deny target is "/") also avoids a redirect loop, since
    // "/" itself is out of the role's scope.
    if (isResourceCoordinator() && !route.startsWith("/tasks")) {
      return <Navigate to="/tasks/task-focus" />;
    }
    return (
      <React.Fragment>
        <RedirectGuard>
          <PermissionGuard permission={permission}>
            <Component />
          </PermissionGuard>
        </RedirectGuard>
      </React.Fragment>
    );
  } else {
    sessionStorage.setItem("session-is-expired", true);
    sessionStorage.setItem("current-page", route);
    return <Navigate to="/logout" />;
  }
};
